import { type Theme as MuiTheme, createTheme } from "@mui/material/styles";

import { FontDefinitions } from "@/assets/fonts.ts";
import { buttonComponentOverrides } from "@/theme/components/ButtonOverrides.ts";
import { chipComponentOverrides } from "@/theme/components/ChipOverrides.ts";
import { popupComponentOverrides } from "@/theme/components/PopupOverrides.ts";
import { skeletonComponentOverrides } from "@/theme/components/SkeletonOverrides.ts";
import { tabsComponentOverrides } from "@/theme/components/TabsOverrides.ts";
import "@/theme/components/SwitchOverrides.ts";
import { TypographyComponentOverrides, defaultTypographyOptions } from "@/theme/components/TypographyOverrides.ts";
import "@/theme/components/ToggleButtonOverrides.ts";
import { lightPalette } from "@/theme/LightTheme.ts";

type CreateThemeDefinitionType = Parameters<typeof createTheme>[0];

export const createThemeDefinition: CreateThemeDefinitionType = {
  cssVariables: true,
  colorSchemes: {
    light: {
      palette: lightPalette,
    },
  },

  defaultColorScheme: "light",
  spacing: (factor: number) => `${0.125 * factor}rem`,

  // Apply font typeset from Figma
  typography: defaultTypographyOptions,
  components: {
    MuiCssBaseline: {
      styleOverrides: `
    ${FontDefinitions.NunitoSans}
    `,
    },
    MuiButton: buttonComponentOverrides,
    MuiChip: chipComponentOverrides,
    ...popupComponentOverrides,
    MuiSkeleton: skeletonComponentOverrides,
    ...tabsComponentOverrides,
    MuiTypography: TypographyComponentOverrides,
  },
};

export type Theme = MuiTheme;

export const appTheme = createTheme(createThemeDefinition);
